import type { IndividualDeadline } from '../firestore/SectionAssignment/schema'

function getIndividualDeadlineEnd(
  individualDeadline?: IndividualDeadline
): Date | undefined {
  if (!individualDeadline) return undefined

  const { overdueAt, expiresAt } = individualDeadline
  if (overdueAt && expiresAt) {
    return overdueAt > expiresAt ? overdueAt : expiresAt
  }
  return overdueAt ?? expiresAt
}

export function getEffectiveAssignmentExpiresAt({
  assignmentExpiresAt,
  individualDeadline,
}: {
  assignmentExpiresAt?: Date
  individualDeadline?: IndividualDeadline
}): Date | undefined {
  return getIndividualDeadlineEnd(individualDeadline) ?? assignmentExpiresAt
}
